export const TEEN_REVIEW_DETAIL_EVENTS = {
  VIEW_ADD_KID_CONFIRM_INFO: 'view_add_kid_confirm_info',
  SELECT_ADD_KID_EDIT_INFO: 'select_add_kid_edit_info',
  SELECT_ADD_KID_CONFIRM_EDIT_INFO: 'select_add_kid_confirm_edit_info',
} as const;
